/** Redondeo estable a N decimales, evitando artefactos de coma flotante. */
export function roundTo(value: number, decimals: number): number {
  const factor = 10 ** decimals;
  return Math.round((value + Number.EPSILON) * factor) / factor;
}

/** Kilogramos con 2 decimales: precision suficiente para micro-discos. */
export function roundKg(value: number): number {
  return roundTo(value, 2);
}

/** Convierte kg a centesimas enteras para comparar sin errores de coma flotante. */
export function toCentigrams(kg: number): number {
  return Math.round(kg * 100);
}

export function fromCentigrams(cg: number): number {
  return roundKg(cg / 100);
}

export function clamp(value: number, min: number, max: number): number {
  if (min > max) throw new Error(`Rango invalido: min ${min} > max ${max}`);
  return Math.min(Math.max(value, min), max);
}

/** Formato español: coma decimal, punto de millares. */
export function formatKg(value: number): string {
  const rounded = roundKg(value);
  return `${rounded.toLocaleString('es-ES', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })} kg`;
}
